import React, { Component } from 'react'
import InputTextUI from './InputTextUI.js'

class InputTextSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value,
      clientError: null
    }
  }

  render() {
    return (
      <InputTextUI
        type={this.props.type}
        name={this.props.name}
        value={this.props.value}
        maxLength={this.props.maxLength}
        onChange={this.onChange}
        label={this.props.label}
        help={this.props.help}
        messageList={this.props.messageList}
        labelKey={this.props.labelKey}
        helpKey={this.props.helpKey}
        required={this.props.required}
        error={this.state.clientError || this.props.error}
        setClientError={this.setClientError}
        autoFocus={this.props.autoFocus}
        disabled={this.props.disabled}
      />
    )
  }

  onChange = (event) => {
    if (this.props.disabled)
      return
    let text = event.target.value
    switch (this.props.type) {
      case 'code':
        if (!text.match(/^[a-zA-Z0-9-_]*$/))
          return
        break
      case 'alphanumeric':
        if (!text.match(/^[a-zA-Z0-9]*$/))
          return
        break
      case 'positive_integer':
        if (!text.match(/^[0-9]*$/))
          return
        break
      case 'price':
        if (!text.match(/^\d{0,10}(?:\.\d{0,2})?$/))
          return
        break
      case 'percentage':
        if (!text.match(/^\d*(?:\.\d*)?$/))
          return

        if (text !== '' && Number(text) > 100)
          return
        break
      default:
    }
    this.props.onChange(event)
  }

  // this is used in FormSF (dynamically) to change border color
  setClientError = (clientError) => {
    this.setState({ clientError: clientError })
  }

}

export default InputTextSF
